import { atom, useAtom, useAtomValue, useSetAtom } from "jotai";

import type { BasePropertyListingProps } from "./BasePropertyListing";

export const selectedPropertiesAtom = atom<BasePropertyListingProps["id"][]>([]);

export const useSelectedPropertiesState = () => useAtom(selectedPropertiesAtom);
export const useSelectedPropertiesValue = () => useAtomValue(selectedPropertiesAtom);
export const useSetSelectedProperties = () => useSetAtom(selectedPropertiesAtom);
